/**
 * Footer Component
 *
 * Shared footer with links and contact information.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';
// import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';

// Register icons for this component
library.add(faLinkedin, faYoutube);

import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer>
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-8 border-t text-sm text-muted-foreground">
          <div className="space-y-2">
            <p className="font-semibold text-foreground">Examfy</p>
            <p>&copy; {new Date().getFullYear()} Examfy Saúde Digital Ltda.</p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.linkedin.com/company/examfy-saude/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground transition-colors"
                aria-label="Examfy no LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedin} className="text-lg" />
              </a>
              <a
                href="https://www.youtube.com/@examfy-org"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground transition-colors"
                aria-label="Examfy no YouTube"
              >
                <FontAwesomeIcon icon={faYoutube} className="text-lg" />
              </a>
            </div>
          </div>
          <div className="space-y-2">
            <p className="font-semibold text-foreground">Links</p>
            <div className="flex flex-col gap-1">
              <Link to="/about" className="hover:text-foreground transition-colors">Sobre</Link>
              <Link to="/terms" className="hover:text-foreground transition-colors">Termos de Uso</Link>
              <Link to="/privacy" className="hover:text-foreground transition-colors">Política de Privacidade</Link>
              <Link to="/contact" className="hover:text-foreground transition-colors">Contato</Link>
            </div>
          </div>
          <div className="space-y-2">
            <p className="font-semibold text-foreground">Aviso</p>
            <p className="text-xs leading-relaxed">
              O Examfy é uma plataforma de gestão de exames e documentos de saúde. Não substitui
              o diagnóstico, prescrição ou acompanhamento médico. Sempre consulte um profissional de saúde qualificado.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
